import { List,Record } from "immutable";

import createFromJS from "../../../createFromJS";
import { DateDisplayRecord } from "../shared/DateDisplayRecord";
import { TimespanDisplayRecord } from "../shared/TimespanDisplayRecord";

export const InspectorConstraintRecord = Record({
  ids: List(),
  constraintType: null,
  thisTarget: null,
  other: null,
  otherLabel: null,
  otherTarget: null,
  comparison: null,
  date: DateDisplayRecord(),
  offset: TimespanDisplayRecord(),
  partPrecision: null,
  partValue: null,
  isViolated: false,
  resolutionOptions: List()
});

const data = {
  objects: {
    ids: "List",
    offset: "TimespanDisplayRecord",
    date: "DateDisplayRecord"
  },
  collections: {
    resolutionOptions: "InspectorConstraintResolutionRecord"
  }
};
createFromJS.registerCallback(
  "InspectorConstraintRecord",
  createFromJS.createNestedCallback(InspectorConstraintRecord, data)
);
